import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CommonModule } from '@angular/common';

export interface ResidenceHistoryDialogData {
  currentAddress?: string; // Optional for contact info dialog
  newAddress?: string;
  extractedDateOfBirth?: string;
  profileDateOfBirth?: string;
  isContactInfoDialog?: boolean; // Flag to customize dialog for contact info update
  isProfileUpdateDialog?: boolean; // Flag for profile auto-update success dialog
  isUpdatingProfile?: boolean; // NEW: Show loading state while updating profile
  showResidenceHistory?: boolean; // NEW: Show residence history question after profile update
  hasResidenceHistory?: boolean; // NEW: Whether residence history should be shown
  dobUpdated?: boolean; // Was DOB updated
  addressUpdated?: boolean; // Was address updated
  dateOfBirth?: string; // DOB value for display
  address?: string; // Address value for display
  licenseIssueDate?: Date; // NEW: License issue date for residence history
  showSuccessMessage?: boolean; // NEW: Show comprehensive success message for new licenses
  residenceHistoryUpdated?: boolean; // NEW: Was residence history updated
  autoCloseDelay?: number; // NEW: Auto-close after N milliseconds
}

@Component({
  selector: 'app-residence-history-dialog',
  templateUrl: './residence-history-dialog.component.html',
  styleUrls: ['./residence-history-dialog.component.scss'],
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule, MatProgressSpinnerModule]
})
export class ResidenceHistoryDialogComponent {
  isProcessing = false;

  constructor(
    public dialogRef: MatDialogRef<ResidenceHistoryDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ResidenceHistoryDialogData
  ) {
    // If autoCloseDelay is set, auto-close after the delay
    if (this.data.autoCloseDelay && this.data.showSuccessMessage) {
      setTimeout(() => {
        this.dialogRef.close(true);
      }, this.data.autoCloseDelay);
    }
  }

  get showLoading(): boolean {
    return this.data.isUpdatingProfile === true;
  }

  get showResidenceQuestion(): boolean {
    return !this.data.isUpdatingProfile && 
           this.data.hasResidenceHistory && 
           this.data.showResidenceHistory === true;
  }

  get showSuccessMessage(): boolean {
    return this.data.showSuccessMessage === true;
  }

  formatDateForDisplay(dateString: string): string {
    if (!dateString) return '';
    
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('en-US', { 
        year: 'numeric', 
        month: 'long', 
        day: 'numeric' 
      });
    } catch {
      return dateString;
    }
  }

  onConfirm(): void {
    if (this.data.isProfileUpdateDialog || this.data.isContactInfoDialog) {
      // For profile update or contact info dialog, just close (user will navigate to profile)
      this.dialogRef.close(true);
    } else if (this.showResidenceQuestion) {
      // For residence history question in the seamless flow, return true
      this.dialogRef.close(true);
    } else if (this.showSuccessMessage) {
      // For success message, close and navigate to profile
      this.dialogRef.close(true);
    } else {
      // For residence history dialog, set processing state and let parent handle
      this.isProcessing = true;
    }
  }

  onCancel(): void {
    if (!this.isProcessing) {
      this.dialogRef.close(false);
    }
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
}


